import { IS_EVIDENCE_OFFLINE_FAIL_FAST_ENABLED } from '@/features/flags/legacy-flags';
import { isBrowserOffline } from '@/utils/isBrowserOffline';

/**
 * Skip Evidence stream recovery when the fail-fast flag is on and the browser
 * reports offline. Must not gate the send: `navigator.onLine === false` is not
 * proof the tab cannot reach the API (EVI-2557).
 */
export function shouldEvidenceFailFastWhenOffline(): boolean {
  return IS_EVIDENCE_OFFLINE_FAIL_FAST_ENABLED() && isBrowserOffline();
}
